import React from "react";
import "./Checkout.css";
import ads from "../../images/ads.jpg";
import Subtotal from "./Subtotal";
import CheckoutProduct from "./CheckoutProduct";
import { connect } from "react-redux";
import { getCartDetailsSelector } from "../../Reducers/AddToCartReducer";
import { getUserNameSelector } from "../../Reducers/AuthenticationReducer";

function Checkout({ cartDetails, userNameFromEmail }) {
  return (
    <div className="checkout">
      <div className="checkout__left">
        <img src={ads} alt="advertisement" className="checkout__ad" />
        <div>
          <h2 className="checkout_welcome">
            Hello, {userNameFromEmail || "Guest"}
          </h2>
          <h2 className="checkout_title">Your Shopping Cart</h2>
          {cartDetails.map(({ id, title, price, image, rating, quantity }) => (
            <CheckoutProduct
              id={id}
              title={title}
              price={price}
              image={image}
              rating={rating}
              quantity={quantity}
            />
          ))}
        </div>
      </div>
      <div className="checkout__right">
        <Subtotal />
      </div>
    </div>
  );
}

export default connect(
  (state) => ({
    cartDetails: getCartDetailsSelector(state),
    userNameFromEmail: getUserNameSelector(state),
  }),
  null
)(Checkout);
